/* Poké Atelier : de la boutique à la page de paiement maison (pay.jellyaddict-fr.com puis pay.pokeatelier.com, Monetico).
   Même mécanique que Run Peak, Jelly Addict et les autres boutiques (éprouvée en production) : le panier Shopify est
   transmis, la page de paiement s'ouvre avec son identifiant. Si la transmission échoue (réseau), on retombe sur le
   paiement Shopify. Les boutons de paiement accéléré (Shop Pay…) sont retirés : ils contourneraient la page maison. */
(function () {
  var FALLBACK = '/checkout';
  var HANDOFF = 'https://pay.pokeatelier.com/api/checkout/handoff';
  var busy = false;
  function isCheckoutControl(el) {
    if (!el) return false;
    if (el.name === 'checkout') return true;
    if (el.id === 'checkout' || el.id === 'CartDrawer-Checkout') return true;
    if (el.classList && el.classList.contains('cart__checkout-button')) return true;
    if (el.tagName === 'A') {
      var href = el.getAttribute('href') || '';
      if (/^\/checkout(\b|\/|\?|$)/.test(href)) return true;
    }
    return false;
  }
  function withTimeout(p, ms) {
    return new Promise(function (resolve, reject) {
      var t = setTimeout(function () { reject(new Error('timeout')); }, ms);
      p.then(function (v) { clearTimeout(t); resolve(v); }, function (e) { clearTimeout(t); reject(e); });
    });
  }
  function handoff() {
    var shop = (window.Shopify && window.Shopify.shop) || location.hostname;
    return withTimeout(fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }), 8000)
      .then(function (cart) {
        var items = (cart.items || []).map(function (i) { return { variant_id: i.variant_id, quantity: i.quantity, properties: i.properties || {} }; });
        if (!items.length) throw new Error('panier vide');
        return withTimeout(fetch(HANDOFF, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ shop: shop, cart_token: cart.token, items: items }), credentials: 'omit' }), 10000);
      })
      .then(function (r) { return r.json(); })
      .then(function (j) { if (!j || !j.url) throw new Error('réponse invalide'); window.location.href = j.url; });
  }
  function leave() { handoff().catch(function () { window.location.href = FALLBACK; }); }
  function go(e, el) {
    e.preventDefault();
    e.stopPropagation();
    if (busy) return;
    busy = true;
    if (el && 'disabled' in el) el.disabled = true;
    leave();
  }
  /* Départ direct vers la page de paiement depuis un autre script */
  window.pmCheckout = function () { if (busy) return; busy = true; leave(); };

  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('button, input[type="submit"], a') : null;
    if (isCheckoutControl(el)) go(e, el);
  }, true);

  /* Boutons de paiement accéléré (« Acheter avec Shop », « Plus de moyens de paiement ») : retirés dès qu'ils apparaissent */
  function strip(root) {
    var nodes = (root || document).querySelectorAll('.shopify-payment-button, .accelerated-checkout-block, [data-shopify="payment-button"], shopify-accelerated-checkout, shopify-accelerated-checkout-cart');
    for (var i = 0; i < nodes.length; i++) nodes[i].remove();
  }
  strip();
  if (window.MutationObserver) new MutationObserver(function () { strip(); }).observe(document.documentElement, { childList: true, subtree: true });
})();
